import React from "react";
import "./AboutPage.css"; // Ensure this file contains the CSS you provided

const AboutPage = () => {
  return (
    <div className="about-container">
      <h2 className="about-title">About Us</h2>
      <p className="about-text">
        Get ready to experience <b>l’art du café</b> ☕✨
      </p>
      <p className="about-text">
        A cozy new coffee spot where every cup is crafted with passion and artistry.  
        Join us soon to savor exceptional coffee and ambiance.
      </p>

      <h3 className="about-title">Adaroza Coffee</h3>
      <p className="about-text">
        <b>Adresse:</b> Rue Ghar El Mehl 7, Lac 1
      </p>
      <p className="about-text">
        <b>Horaires:</b>  
        <br /> Lundi – Vendredi, 6:30 → 20:00  
        <br /> Samedi – Dimanche, 8:00 → 20:00
      </p>

      <div className="social-media">
          <a href="https://www.facebook.com/profile.php?id=61565563451949" target="_blank" rel="noopener noreferrer" className="social-icon">
            <img src="/images/facebook-icon.webp" alt="Facebook" />
          </a>
          <a href="https://www.instagram.com/adaroza_cafe?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer" className="social-icon">
            <img src="/images/Insta-icon.webp" alt="Instagram" />
          </a>
          <a href="https://www.tiktok.com/@adaroza_cafe" target="_blank" rel="noopener noreferrer" className="social-icon">
            <img src="/images/tiktok icon.webp" alt="Tiktok" />
          </a>
        </div>
    </div>
  );
};

export default AboutPage;
